import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setThemeColor } from 'actions/index';
import { DARK_THEME_COLOR } from 'constants/ThemeColors';

export default function useModuleTheme(tema) {
  const dispatch = useDispatch();
  const { themeColor } = useSelector(({ settings }) => settings);

  useEffect(() => {
    const sideBarDark = localStorage.getItem('sidebar_dark') === 'true';
    const corDoModulo = sideBarDark ? tema.escuro : tema.claro;

    if (themeColor === corDoModulo) return;

    dispatch(setThemeColor(corDoModulo));

    const body = document.body.classList;
    body.remove(themeColor);
    body.remove(DARK_THEME_COLOR);
    body.add(corDoModulo);
  }, [tema, themeColor]);
}
